import { Project } from '@qality/common-model';

import APIConstants from './APIConstants';
import ProjectServiceUnique from './ProjectServiceUnique';

export default {
  async getAllAdministeredProjects(): Promise<Array<Project>> {
    return ProjectServiceUnique.getProjects(
      APIConstants.URL_SEARCH_ADMINISTERED_PROJECTS
    );
  },
};
